
export const CalculateSumary = (array, key) => {
    let sumTotal = array.reduce((acc, item)=> {
        if(item[key] != ''){
            return acc + parseFloat(item[key])
        }
        return acc
    }, 0)
    return sumTotal
} 